import {createFileRoute} from '@tanstack/react-router';

import {CreateCategoryPresetForm} from '@/features/Library/components/CategoryPreset/CreateCategoryPresetForm';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute(
  '/_b/_p/_library/categories/preset/create'
)({
  component: CreateCategoryPresetForm,
  beforeLoad: () => makeDocumentTitle('Create Category Preset'),
});
